import SyPin from "./sy-pin";

export default SyPin